import { ICONS } from '@client/constants/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/controls')({
    staticData: {
        breadcrumb: {
            title: 'Controls',
            inactive: true,
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        modules: ['risk', 'compliance'],
        ui: {
            icon: ICONS.control,
        },
    },
    component: Outlet,
});
